import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, switchMap } from 'rxjs';
import { of } from 'rxjs';
import { ProjectContextService } from '../services/project-context.service';
import { ProjectRouteService } from '../services/project-route.service';
import { projectLink } from '../utils/project-route.util';

/** Project settings gate: only PROJECT_ADMIN can enter. */
export const projectAdminGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const context = inject(ProjectContextService);
  const projectRoute = inject(ProjectRouteService);
  const raw = route.paramMap.get('projectSlug') ?? route.parent?.paramMap.get('projectSlug') ?? '';
  if (!raw.trim()) {
    return router.createUrlTree(['/dashboard']);
  }

  return projectRoute.ensureResolved(raw).pipe(
    switchMap((projectId) => {
      if (projectId == null || projectId <= 0) {
        return of(router.createUrlTree(['/dashboard']));
      }
      const meta = projectRoute.meta();
      const boardLink = meta ? projectLink(meta, 'board') : ['/projects', raw, 'board'];
      const known = context.getRole(projectId);
      if (known !== undefined) {
        return of(known === 'PROJECT_ADMIN' ? true : router.createUrlTree(boardLink));
      }
      return context
        .ensureLoaded(projectId)
        .pipe(map((role) => (role === 'PROJECT_ADMIN' ? true : router.createUrlTree(boardLink))));
    }),
  );
};

